app.controller("StudentExamsListController", [
    "$scope", "Lecturer", "Users", "$uibModal", "ConfirmModal", "$stateParams", "$http", "usSpinnerService", "$timeout",
    function ($scope, Lecturer, Users, $uibModal, ConfirmModal, $stateParams, $http, usSpinnerService, $timeout) {
        $scope.query = $stateParams.query;
        $scope.schedule = [];
        $scope.isEmpty = false;

        $scope.fetchList = function() {
            $scope.isEmpty = false;
                usSpinnerService.spin("root");
            $http.get("/exams/student/list", {}).then(function (res) {
                $scope.schedule = res.data;
                if(res.data.length == 0){
                    $scope.isEmpty = true;
                }
                usSpinnerService.stop("root");
            }, function (err) {
                $scope.isEmpty = true;
                usSpinnerService.stop("root");
            });
        };

        $scope.fetchList();
    }
]);